import utils from '@utils';

/**
 * カスタマーの単体取得
 */
export const getOneCustomer = async (customerId: string) => {
  const res = await utils.axios.slsGo().get(`/payments/customer/${customerId}`);

  return res.data;
};

/**
 * カスタマーの登録
 * - クレジットカード登録時に実行
 */
export const createCustomer = async (b: PaymentCreateCustomerBody) => {
  const res = await utils.axios.slsGo().post(`/payments/customer`, b);

  return res.data;
};

/**
 * カスタマーの削除
 * - 退会時に実行
 */
export const deleteCustomer = async () => {
  const res = await utils.axios.slsGo().delete(`/payments/customer`);

  return res.data;
};

/**
 * クレジットカードの登録
 * - Stripe的にはCustomerに対してカードを登録
 */
export const createCard = async (b: PaymentCreateCardBody) => {
  const res = await utils.axios.slsGo().post(`/payments/card`, b);

  return res.data;
};

/**
 * クレジットカードの削除
 * - カード更新時に実行
 * - Stripe的にはCustomerに対してカードを削除
 */
export const deleteCard = async (customerId: string) => {
  const res = await utils.axios.slsGo().delete(`/payments/card/${customerId}`);

  return res.data;
};

/**
 * サブスクリプションの登録
 * - プランの初登録時に実行
 */
export const createSubscription = async (b: PaymentCreateSubscriptionBody) => {
  const res = await utils.axios.slsGo().post(`/payments/subscription`, b);
  return res.data;
};

/**
 * 最大利用数の登録
 * - ユーザー追加時・削除時に実行
 * - Stripeの従量課金の最大ユーザー数を更新する
 */
export const createUsageRecord = async (b: PaymentCreateUsageRecordBody) => {
  const res = await utils.axios.slsGo().post(`/payments/usage_record`, b);
  return res.data;
};

/**
 * サブスクリプションの削除
 * - フリープラン・解約時に実行
 * - キャンセル処理
 */
export const deleteSubscription = async (
  qp: PaymentDeleteSubscriptioQueryParams
) => {
  const res = await utils.axios.slsGo().delete(`/payments/subscription`);

  return res.data;
};
